<div class="d-flex my-3">
    <div class="d-block">
        <img [src]="userImage" alt="P2P Donations Image" class="img-fluid rounded-start" style="height: 88px; min-width: 88px; border-radius: 4px;">
    </div>
    <div class="d-flex flex-column w-100 ml-4 mr-3">
            <span class="body-2" style="color: #676767;">{{optionName}}</span>
            <span class="subtitle-1--weight-regular">{{displayName}}</span>
            <span class="caption" style="color: #676767;">{{name}}</span>
            <div class="row mt-auto">
            <div class="d-block progress md-progress p2p-detail-progress"
                [innerHTML] = "progressBarHtml">                                
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-between">
    <button (click)="p2pAddDonationsModalOpen()" type="button" aria-expanded="false" 
        class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex">
        Add Donation
    </button>
    @if(isTransactionsExist) {
        <button (click)="exportToExel()" type="button" aria-expanded="false" 
            class="btn btn-sm modal-cancel-button waves-effect waves-light caption text-nowrap d-flex">
            Export Donations
        </button>
    }
</div>

<mdb-tabs #tabs class="mdb-tabs mdb-tabs--p2p">
    <mdb-tab title="Donations ({{data.transactions.length}})">
        <div class="grey-background">
            @if(isTransactionsExist) {
                <div class="p2p-donations-container m-4 px-3">
                    <div class="d-flex border-bottom mt-2 pb-2">
                        <div class="d-flex w-100 align-items-center subtitle-2--regular">
                            <div class="col-6 p-0">
                                Donor
                            </div>
                            <div class="col-2 p-0">
                                Amount
                            </div>
                            <div class="col-4 p-0 d-flex justify-content-end pr-4">
                                Date
                            </div>
                        </div>
                    </div>
                    <app-p2p-details-donations-info (selectedDonor)="donorSelected($event)"></app-p2p-details-donations-info>
                </div>
            } @else {
                <div class="d-flex my-5 justify-content-center align-items-center">
                    No Existing Donations...
                </div>
            }
        </div>
    </mdb-tab>
    @if(showPledges) {
        <mdb-tab title="Pledges ({{pledges.length}})">
            <div class="grey-background">
                @if(pledges.length > 0) {
                    <div class="p2p-donations-container m-4 px-3">
                        <div class="d-flex border-bottom mt-2 pb-2">
                            <div class="d-flex w-100 align-items-center subtitle-2--regular">
                                <div class="col-5 p-0">
                                    Donor
                                </div>
                                <div class="col-2 p-0">
                                    Pledge Per Milestone
                                </div>
                                <div class="col-2 p-0 text-center">
                                    Status
                                </div>
                                <div class="col-2 p-0 d-flex text-center">
                                    Amount
                                </div>
                                <div class="col-1"></div>
                            </div>
                        </div>
                        @for(pledge of p2pPledges; track pledge.id) {
                            <div class="d-flex border-bottom mt-2 pb-2">
                                <div class="d-flex w-100 align-items-center">
                                    <div class="col-5 name-container" style="word-wrap: break-word;">
                                        <span class="name-container__name subtitle-1">{{pledge.donorInfo.name}}</span> <br>
                                        <span class="name-container__email grey-text">{{pledge.donorInfo.email}}</span>
                                    </div>
                                    <div class="col-2 p-0">
                                        <span class="subtitle-2--regular">{{pledge.amount | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                                    </div>
                                    <div class="col-2 p-0 text-center">
                                        @if(pledge.status == 0 ){
                                            <span class="subtitle-2--regular">Pending</span>
                                        } @else if(pledge.status == 1 ){
                                            <span class="subtitle-2--regular">Charged</span>
                                        } @else if(pledge.status == 2){
                                            <span class="subtitle-2--regular">Failed</span>
                                        } @else if(pledge.status == 3) {
                                            <span class="subtitle-2--regular">Deleted</span>
                                        } @else{
                                            <span class="subtitle-2--regular">NA</span>
                                        }
                                    </div>
                                    <div class="col-2 p-0 text-center">
                                        @if(pledge.status == 0 ){
                                            <span class="subtitle-2--regular">NA</span>
                                        } @else if(pledge.status == 1 ){
                                            <span class="subtitle-2--regular">{{pledge.amountCharged | currency:'USD':'symbol-narrow':'1.0-0'}}</span>
                                        } @else if(pledge.status == 2 ){
                                            <span class="subtitle-2--regular">NA</span>
                                        } @else{
                                            <span class="subtitle-2--regular">NA</span>
                                        } 
                                    </div>
                                    <!-- @if(pledge.status == 0) { -->
                                        <div class="col-1">
                                            <div class="d-flex show" x-placement="bottom-end">                                
                                                <app-p2p-donations-popover [data]="pledge"></app-p2p-donations-popover>
                                            </div>
                                        </div>
                                        <!-- <div (click)="onClickDeletePledge(pledge)" class="col-1 text-center cursor-pointer">
                                            <i class="fas fa-minus-circle" style="color: #ff0000;"></i>
                                        </div> -->
                                    <!-- } -->
                                </div>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="d-flex my-5 justify-content-center align-items-center">
                        No Existing Pledges...
                    </div>
                }
            </div>
        </mdb-tab>
    }
</mdb-tabs>
